import React from "react";
import { Segment, Strip } from "./RunStrip.styles";
import type { RunStripProps } from "./RunStrip.types";

/** A thin line of one segment per day, coloured by that day's worst run. */
export const RunStrip: React.FC<RunStripProps> = ({ cells, ariaLabel, className }) => (
  <Strip className={className} role="img" aria-label={ariaLabel}>
    {cells.map((status, index) => (
      <Segment key={index} $status={status} data-status={status} />
    ))}
  </Strip>
);

export default RunStrip;
